import { Action, createReducer, on } from '@ngrx/store';
import { fromProductProvidersAction } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataResponse } from '../models/static-data.model';

export const productProvidersFeatureKey = 'productProviders';

export interface ProductProvidersState {
  productProvidersResponse: IStaticDataResponse[];
  productProvidersFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: ProductProvidersState = {
  productProvidersFailure: undefined,
  productProvidersResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromProductProvidersAction.loadProductProviders, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromProductProvidersAction.loadProductProvidersSuccess, (state, action) => ({
    ...state,
    productProvidersResponse: action.response
  })),

  on(fromProductProvidersAction.loadProductProvidersFailure, (state, action) => ({
    ...state,
    productProvidersFailure: action.error
  }))
);

export const getProductProvidersResponse = (state: ProductProvidersState) => state.productProvidersResponse;
export const getProductProvidersFailure = (state: ProductProvidersState) => state.productProvidersFailure;
export const getProductProvidersIsLoaded = (state: ProductProvidersState) => state.loaded;
